import React from "react";
import {Route} from "react-router-dom";
import auth from "../auth/auth";
import {Redirect} from "react-router";
import Permissions from "../auth/permissions";
import {setRedirect} from "../App";
import {BaseLoginURL} from "../urls";
import {CustomBreadcrumbs} from "../components/CustomBreadcrumbs";
import {Hide} from "../components/Hide";

const ProtectedRoute = ({component: Component, ...rest}) => {
    setRedirect(rest.location.pathname);
    return (
        <>
            <Hide hide={rest.hide_bc}>
                <CustomBreadcrumbs match={rest.computedMatch}/>
            </Hide>

        <Route {...rest}  render={(props) => {
            return (
                (auth.isAuthenticated()) && (rest.permission === true || Permissions.checkAllPermissions(rest.permission)) ?
                    <Component {...props}/> : <Redirect to={BaseLoginURL}/>
            )
        }}/>
        </>
    )
};

export default ProtectedRoute;
